import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n  <path d=\"M8.00005 9.41929L11.076 12.4952L11.9952 11.576L8.91929 8.50005L11.9952 5.42415L11.076 4.50491L8.00005 7.58081L4.92412 4.50488L4.00488 5.42412L7.08081 8.50005L4.00488 11.576L4.92412 12.4952L8.00005 9.41929Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol